import { useSelector } from "react-redux"
import store from "~Shared/store"
import { RootState } from "~Shared/store/rootState.interface"
import { mapFeatureFlagsToTenantTier } from "~Shared/utils/tenant.utils"

export const useIsPaidVersion = () => useFeatureFlags()?.paidVersion

export const useIsFreeVersion = () => !useIsPaidVersion()

export const useTenantTier = () => mapFeatureFlagsToTenantTier(useFeatureFlags())

export const useIsPersonioEnabled = () => useFeatureFlags()?.personioEnabled ?? false

export const useIsOutgoingWireTransferEnabled = () => useFeatureFlags()?.outgoingWireTransferEnabled

export const useIsCostCenterGroupsEnabled = () => useFeatureFlags()?.costCenterGroupsEnabled

export const useIsCustomCsvTemplatesEnabled = () => useFeatureFlags()?.customCsvTemplatesEnabled

export const useIsSubCompaniesEnabled = () => useFeatureFlags()?.subCompaniesEnabled

export const useIsTravelEnabled = () => useFeatureFlags()?.travelEnabled

export const useIsCustomRolesEnabled = () => useFeatureFlags()?.customRolesEnabled

export const useIsPurchaseOrderEnabled = () => useFeatureFlags()?.purchaseOrderEnabled ?? false

export const useIsPurchaseRequestEnabled = () => useFeatureFlags()?.purchaseRequestEnabled ?? false

export const getIsTravelEnabledFeatureFromStore = (): boolean => store.getState().featureFlags.item.travelEnabled

const useFeatureFlags = () => useSelector(({ featureFlags }: RootState) => featureFlags.item)
